export const jsBridgeFunctions = {
    setStreamVolume: 'setStreamVolume',
};

export const jsBridgeFunctionsEnums = {
    [jsBridgeFunctions.setStreamVolume]: {
        voice: 'voice',
        music: 'music',
    }
}